
import { EditingDocument } from "../../../../applications/documaker/components/document/editor";
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import {
  Document,
} from "../../../../domain/document";
import { FormatReference } from "../../../../domain/format";
import { Patient } from "../../../../domain/patient";
import { default as NewDocumentEditorBaseMixin } from "./NewDocumentEditorBaseMixin.vue";

@Component({
})
export default class NewLatestQuotedDocumentEditorMixin extends Mixins(NewDocumentEditorBaseMixin) {
  @Prop()
  getDocumentForLatestQuotation: (patientNo: string, documentId: number) => Promise<Document>;

  @Watch("patient")
  onPatientUpdated(newValue: Patient, oldValue: Patient): void {
    this.loadNewDocument();
  }

  @Watch("format")
  onFormatUpdated(newValue: FormatReference, oldValue: FormatReference): void {
    this.loadNewDocument();
  }

  async initializeAndLatestQuoteDocument(source: Document, institutionNo: string, regionalInstitutionNo: string, hisInfoGetterParameter: string): Promise<void> {
    const patientNo = this.patient
      ? this.patient.id
      : this.patientNo;
    try {
      const results = await Promise.all([
        this.initializeDocumentAsync(source, institutionNo, regionalInstitutionNo, hisInfoGetterParameter),
        this.getInitializedDocumentForLatestQuotationAsync(patientNo, this.format.id),
      ]);
      const documentForLatestQuotation = results[1];
      if (documentForLatestQuotation
        && (!documentForLatestQuotation.unmanagedInformation || documentForLatestQuotation.unmanagedInformation.isQuotable)) {
        const document = await this.mergeDocumentAndApplyPatientProfileAsync(source, documentForLatestQuotation);
        if (document) {
          document.freezeItems();
        }
        this.editingSource = document;
      } else {
        this.$warn("引用文書なし", "記載済みの引用可能な文書がないため、新規に文書を記載します。");
      }
    } catch (e) {
      this.$fatal(
        "引用・初期化失敗",
        "指定された文書(source)と施設番号(institutionNo, regionalInstitutionNo, hisInfoGetterParameter)の引用・初期化が失敗しました。",
        e
      );
    }
  }

  async initializeDocumentAsync(source: Document, institutionNo: string, regionalInstitutionNo: string, hisInfoGetterParameter: string): Promise<void> {
    if (this.initialize) {
      await this.initialize(source, institutionNo, regionalInstitutionNo, hisInfoGetterParameter);
    }
  }

  async getInitializedDocumentForLatestQuotationAsync(patientId: string, formatId: number): Promise<Document> {
    this.$logger.info("引用・転記元の文書を取得します。FormatID:" + formatId);
    const document = await this.getDocumentForLatestQuotation(patientId, formatId);
    if (!document) {
      this.$logger.info("直近文書が存在しないため引用しません。");
      return null;
    }
    const editingDocument = new EditingDocument(document);
    // 値を取得する文書の計算式を走らせる必要あるのかどうか・・？
    // 不要な気がしないでもない
    try {
      await editingDocument.initialize(); // 計算式の更新等初期化する.
    } catch (e) {
      this.$error("エラー", e.message, e);
    }
    return document;
  }
}
